export default {
	message: {
		common:
		{
			update_successfully: '更新成功'

		},
		header:
		{
			Systemdoes:"系统没有配置快照，请添加配置快照",

			alarm: '报警',
			see_alarm: '查看所有报警',
			search: '搜索',
			user_name: '用户名',
			setting: '帐号设置',
			logout: '退出',
			logouts: '退出登录',
			login: '登录',
			API: "API",
			goto: "前往下载",
			control: "请在下载安装插件",
			Reboot: "重启"
		},
		left:
		{
			VIDEO: "视频平台控制中心",
			Control: "控制中心",
			navigation: '导航',
			dashboard: '仪表盘',
			live: '实时视频',
			playback: '回放',
			AdvancePB: '高级回放',
			archive: '归档',
			screenshots: "文件夹",
			snapshot: '抓图',
			event: "事件",
			setting: '设置',
			tour: "巡更",
			cloud: '云视频',
			logout: '退出',
			camera: "监控点",
			VideoConference: "视频会议",
			MapManagement:"地图管理",
			Map:"地图"
		},
		login:
		{
			return: "返回",
			high_perf: '高性能HTML5原生视频',
			signin: '登录到管理界面',
			login: '登录',
			login_status_failed: '用户名或密码不正确',
			username: '用户名',
			password: '密码',
			language: '语言选择'
		},
		dashboard:
		{
			Storage: "存储",
			Copysuccessful: "复制成功",
			about: "关于",
			dashboard: '仪表盘',
			system_info: '系统',
			version: '版本',
			hostid: '主机号',
			license: '版权',
			channel: '通道',
			endtime: '版权结束时间',
			memory: '内存',
			running: '运行',
			network_in: '网络进流量',
			network_out: '网络出流量',
			free_space: "剩余空间",
			an_out: "网络进出流量",
			online_cam: "在线摄像机",
			cameras: "摄像机总数",
			total_space: "总空间",
			codec_info: "编解码器",
			GPU_info: "GPU编解码器",
			cpumodel: 'CPU型号',
			PhysicalCPU: "CPU路数",
			CPUCore: "CPU核数",
			gpuencoder: "GPU编码器",
			gpudecoder: "GPU解码器",
			cpuencoder: "软件编码器",
			cpudecoder: "软件解码器",
			capability: "功能列表",
			devicesdk: "设备SDK",
			device: "设备",
			devicesdkpb: "设备SDK回放",
			gb28181: "国标",
			transcoding: "转码",
			Lingvideo: "Lingvideo",
			Docker: "容器",
			VideoConference: "视频会议",
			cluster: "集群",
			Online: "在线",
			Not_nline: "不在线",
			Platform: "平台",
			Hikvision: "海康SDK",
			Dahua: "大华SDK",
			Tiandy: "天地SDK",
			Uniview: "宇视SDK",
			DiskMemory: "硬盘/内存",
			TotalMemory: "总内存",
			total: "共",
			ge: "个",
			Cloud: "云级联",
			RTMP: "RTMP推流",
			Online: "在线",
			Offline: "离线"

		},
		live:
		{
			View:'视图',
			NewView:'新建视图',
			ViewName:'视图名称',

			LightON:"灯光开",
			LightOFF:"灯光关",
			WiperON:"雨刷开",
			WiperOFF:"雨刷关",
		  	focusing: "调焦",
			Focus: "聚焦",
			aperture: "光圈",
			liveview: '实时视频',
			device: '视频源',
			setting: '设置',
			protocol: '协议',
			mainstream: '主码流',
			substream: "辅码流",
			camera: "摄像机",
			waterprint: "水印",
			Videorecording: "正在录像",
			Region: "区域",
			Scan: "扫扫查看视频",
			Quality: "画质",
			Switched: '已切换',

			Video: "视频",
			Codec: "编码类型",
			Width: "宽",
			Height: "高",
			FPS: "帧率",
			Bitrate: "码率",

			Audio: "音频",
			Codec: "编码类型",
			SampleRate: "采样率",
			SampleBit: "采样位宽",
			Channels: "声道数",
			Bitrate: "码率",

		},
		setting:
		{
			LoadAllChannel:'加载所有通道',
			Sandbox:"沙盒",

			ClientConfiguration:"客户端配置",
			Domainlist:"域列表",
			ForceHTTPS:"强制HTTPS",
			EnableDomain:"开启域",
			DocumentRoot:"文件目录",

			RTCENGINE:"RTC引擎",

			RTSPRTMP:"RTSP/RTMP",
			ONVIF:"ONVIF",
			File:"文件",
			Stremlang:'辅码流URL',

			Audio: "音频",
			DeviceImport:"设备导入", 
			Import:"导入",
			Batchimportdevice:"批量导入设备信息",
			Cancel: "取消",

			Default: "默认",
			Transcoding: "转码管理",
			Profile: "自定义",
			setting: '设置',
			device: '设备',
			record: "录像管理",
			devicesdk: '设备SDK',
			devicertmppush: 'RTMP推流',
			Regional: "区域管理",
			Please: "请输入名字",
			Area: "区域删除/添加",
			Input: "输入框不能为空",
			user: '用户',
			role: '角色',
			Authority: "权限",
			action: '操作',
			edit: '编辑',
			name: '名字',

			username: "用户名",
			Rolemanagement: "角色管理",
			SystemManagement: "系统管理",
			CyberSecurity: "安全管理",
			password: "密码",
			RoleName: "角色名称",
			Configure: "配置权限",
			Operation: "操作权限",
			Camera: "摄像机权限",
			Watchvideo: "匿名观看视频",

			CloudConnect: "级联管理",
			SSL: "SSL协议",
			KeepaliveTime: "保持时间",
			Enable: "开启",
			EdgeTranscoding: "边缘转码",

			CloudMode: '云模式',
			RelayMode: "转发模式",
			TURNServer: "TURN服务",
			Enable: "开启",
			PublicIP: "公网地址",
			MinPort: "最小端口",
			MaxPort: "最大端口",
			PasswordEncrypt: "密码加密",
			//日志
			Log: '日志',
			LogLevel: '日志级别',
			LogRotating: '循环覆盖',
			System: '系统维护',
			Snopshot: '快照',
			SnapshotList: '快照列表',
			Name: '名称',
			Refresh: '刷新',
			Protocol: '协议',
			ServiceDetection: 'RTSP服务检测',

			currentpass: '当前密码',
			newpass: '新密码',
			confirmpass: '重复新密码',
			confirmpassword: '重复密码',
			manualstart: "开启所有通道录像",
			manualstop: "关闭所有通道录像",
			DeleteAll: "删除",
			Detail: "查看",
			Cancel: "取消",
			OK: "确定",
			Configuration: "配置",
			ADD: "添加",
			Change: "修改密码",
			Changecg: "修改成功，请重新登录！",
			Changesb: "修改失败！",
			Twopassword: "两次密码不一致，请重新输入!",
			all: "全部",
			Editorfailure: "编辑失败",
			Creationfailed: "创建失败",
			Illegal: "非法登录锁定"
		},
		table: {
			pleasechoose: "请选择",
			Enterkeywords: "输入关键字",
			Token: "编号",
			Type: "类型",
			Online: "在线状态",
			Edit: "编辑",
			Index: "序号",
			GBID: "国标ID",
			IP: "IP地址",
			Name: "名称",
			Port: "端口",
			User: "用户名",
			UUID: "事件编号",
			Time: "时间",
			Detaill: "详细",
			Tokenevent: "设备编号",
			StartTime: "开始时间",
			EndTime: "结束时间",
			Codec: "视频编码",
			Engine: "引擎",
			FPSType: "帧率类型",
			ScaleType: "分辨率类型",
			Bitrate: "码率",
			FPS: "帧率",
			WH: "宽*高"
		},
		playback: {
			H5SPlayback: "H5S回放",
			NVRPlayback: "NVR回放"
		},
		GB: {
			GB28181: "下级域",
			GBPlatform: "上级域",
			GBService: "GB服务配置",
			main:'主码流',
			sub:'辅码流',

			name: '名字',
			// GB28181:"国标",
			// GBPlatform:"国标平台",
			Name: "名字",
			SIPServerIP: "SIP服务器地址",
			SIPServerPort: "SIP服务器端口",
			SIPPort: "本地SIP端口",
			SIPUserID: "SIP用户ID",
			SIPServerID: "SIP服务器ID",
			Password: "密码",
			SIPProtocol: "SIP协议",
			SIPChannelBaseID: "起始通道编码",
			RegisterPeriod: "注册有效期",
			KeepaliveTime: "心跳周期",
			Domain: "服务器域",
			Refreshsuccess: "刷新成功",
			Restartsuccessfully: "重启成功",
			//service
			GbID: "SIP服务器ID",
			GbServerIpAddr: "SIP服务器地址",
			GbServerPort: "SIP服务器端口",
			PortRangeMin: "端口最小范围",
			PortRangeMax: "端口最大范围",
			GbStreamProto: "流媒体协议",
			GbServerProto: "SIP协议",
			GbTimeout: "超时时间",
			Password: "密码",
			Realm: "SIP服务器域",
			SubAlarm: "订阅报警",
			SubMobilePosition: "订阅位置",
			Enable: "启用",
			EnableAudio: "开启音频",
			EnableSSRCCheck: "SSRC检查",

			Stream:"码流",



			DeleteAll: "删除",
			Detail: "查看",
			Cancel: "取消",
			OK: "确定",
			Configuration: "配置",
			OVER: "全部",
			ADD: "添加",
			edit: '编辑'
		},
		archive: {
			search: '搜索',
			archive: '归档',
			StartTime: "开始时间",
			EndTime: "结束时间",
			ManualRecord: "手动录像",
			AlarmRecord: "报警录像",
			Schedulerecord: "计划录像",
			Refresh: "刷新",
			Download: "下载",
			Playback: "视频回放",
			Name: "名称",
			snapshot: '抓图',
			Clear: "清空",
			Onehour: "最近一小时",
			Oneday: "最近一天",
			Oneweek: "最近一周",
			Onemonth: "最近一个月",
			Time: "截图时间",
			Preview: "预览",
			Picture: "图片",
			Pleaseselectone: "请选择一个"
		},
		tour: {
			Start: "开始",
			stop: "停止",
			Startall:'全部开始'
		},
		camera: {
			Save_successfully: "保存成功！",
			// Editor_failure:"保存失败！",
			Delete_successful: "删除成功！",
			Delete_failed: "删除失败！",
			open_Close: "开启/关闭",
			name: "名称",
			audio: "音频",
			save: "保存"
		},
		Conference: {
			Upload: "上传",
			Videointercom: "视频对讲",
			VideoConference: "视频会议",
			Connect: "连接",
			Disconnect: "断开",
			Call: "通话",
			VideoCall: "接通视频",
			AudioCall: "接通语音",
			HangUp: "挂断",
			Hang: "挂断",
			JoinConference: "加入会议",
			Nickname: "昵称不能为空!"
		},
		cluster:{
			NodeName:'节点名',
			NodeID:"节点编号",
			RedisServerIP:"Redis 服务器地址",
			RedisServerPort:"Redis 服务端口",
			LocalIP:"本机服务器IP地址",
			PleaseHTTP:"请开启HTTP域 !"
		}
	}
}
